import { cva } from "class-variance-authority";

export const dropdownMenuItemVariants = cva(
  "relative flex w-full cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm outline-none",
  {
    variants: {
      variant: {
        primary: "hover:!bg-gray-50",
        destructive: "hover:!bg-red-50",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export const dropdownMenuIconVariants = cva(
  "mr-2 inline-flex h-5 w-5 shrink-0 items-center justify-center",
  {
    variants: {
      variant: {
        primary: "text-gray-400 group-hover:text-gray-600 transition-colors",
        destructive: "text-red-400 group-hover:text-red-600 transition-colors",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export const dropdownMenuTextVariants = cva("min-w-0 flex-1", {
  variants: {
    variant: {
      primary: "text-gray-700 group-hover:text-gray-900 transition-colors",
      destructive: "text-red-600 group-hover:!text-red-700 transition-colors",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});
